import cryptoJs from 'crypto-js'
// 加密函數
export function encryption (word, keywords) {
  let encResult = cryptoJs.AES.encrypt(word, keywords, {
    mode: cryptoJs.mode.CBC,
    padding: cryptoJs.pad.ZeroPadding
  }).toString()
  return encodeURIComponent(encResult)
}
// 解密函數
export function decrypt (word, keywords) {
  let data = decodeURIComponent(word)
  let bytes = cryptoJs.AES.decrypt(data, keywords, {
    mode: cryptoJs.mode.CBC,
    padding: cryptoJs.pad.ZeroPadding
  })
  let decData = bytes.toString(cryptoJs.enc.Utf8)
  return decData
}

// 随申办 APP userInfo 专用解密：与后端 AESUtil 保持一致
// 后端方案：AES/ECB/PKCS5Padding，密钥由 KeyGenerator(SHA1PRNG, seed=keywords) 生成，
// 等价于 key = SHA1(SHA1(seedBytes)) 的前 16 字节；密文为 Base64（后端可能按 76 字符换行）。
export function decryptSsbUserInfo (word, keywords) {
  // 兼容 sun.misc.BASE64Encoder 的换行/空白
  const base64 = String(word || '').replace(/\s/g, '')
  // 复刻 Java SHA1PRNG 派生的 128 位密钥
  const firstSha = cryptoJs.SHA1(cryptoJs.enc.Utf8.parse(keywords))
  const secondSha = cryptoJs.SHA1(firstSha)
  const key = cryptoJs.lib.WordArray.create(secondSha.words.slice(0, 4), 16)
  const bytes = cryptoJs.AES.decrypt(
    { ciphertext: cryptoJs.enc.Base64.parse(base64) },
    key,
    { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 }
  )
  return bytes.toString(cryptoJs.enc.Utf8)
}
